import { atom } from 'jotai'

export enum SocietyNavigationState {
  None = 0,
  SocietyRequests = 1,
}

export const societyNavigationStateAtom = atom(SocietyNavigationState.None)
